import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/69ebe27463911b00141d1c02_1781285753378_293c6ce4/capture_1777066612730/src/app/home/page.tsx");
